module.exports = __webpack_public_path__ + "img/sn-tw-dark.7898806d.svg";